var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490.2 490.2",
    style: {
      enableBackground: "new 0 0 490.2 490.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M429.6,37.5h-84.4V20.9c0-5.2-4.5-20.1-20.9-20.9H166.9C155.4,0,146,9.4,146,20.9v16.7H60.6c-5.6-0.7-20.9,5.9-20.9,20.9 v410.8c0,11.5,9.4,20.9,20.9,20.9h370.1c14.4,0,19.8-15.6,19.8-20.9V58.4C450.5,46.9,441.1,37.5,429.6,37.5z M187.8,40.7h116.8 v35.4H187.8V40.7z M409.8,449.3H80.4V79.2h65.7v16.7c0,11.5,9.4,20.9,20.9,20.9h158.5c10.4,0,19.8-9.4,19.8-19.8V79.2h64.6v370.1 H409.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,245h150.1c11.5,0,19.8-9.4,20.9-20.9c0-11.5-9.4-20.9-20.9-20.9H170c-11.5,0-20.9,9.4-20.9,20.9S158.6,245,170,245z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3,343H173.2c-11.5,0-20.9,9.4-20.9,20.9s9.4,20.9,20.9,20.9h150.1c10.4,0,20.9-9.4,20.9-20.9S334.8,343,323.3,343z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/Notepad.740e71f580d2dbdade1528d337f810bd.svg";
export { ForwardRef as ReactComponent };